import { render, staticRenderFns } from "./CommercialMultitenantMedicalPremises.vue?vue&type=template&id=4b0d3359&scoped=true&"
import script from "./CommercialMultitenantMedicalPremises.vue?vue&type=script&lang=ts&"
export * from "./CommercialMultitenantMedicalPremises.vue?vue&type=script&lang=ts&"
import style0 from "./CommercialMultitenantMedicalPremises.vue?vue&type=style&index=0&id=4b0d3359&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0d3359",
  null
  
)

export default component.exports